import React from 'react';
import PropTypes from 'prop-types';

class InputCheckbox extends React.Component {
  render () {
    let inputProps = { ...this.props };
    delete inputProps.label;
    delete inputProps.className;
    delete inputProps.style;
    delete inputProps.checkboxClassName;
    return (
      <label className={this.props.className} style={this.props.style}>
        <input type="checkbox" className={`push-half--right ${this.props.checkboxClassName}`} {...inputProps} />
        {this.props.label}
      </label>
    );
  }
}

InputCheckbox.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
};

InputCheckbox.defaultProps = {
  checkboxClassName: '',
};

export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/common/views/form/InputCheckbox.js